<template>
  <v-container>
    <h1 class="text-center text-uppercase">SLIDER</h1>
    <v-container>
      <v-row class="text-center">
        <v-col>
          <v-btn color="primary1" dark @click="newSlide = true">
            <v-icon left>mdi-plus</v-icon>NEW SLIDER
          </v-btn>
        </v-col>
        <v-col>
          <v-row>
            <v-col>
              <p class="overline">TOTAL CATEGORY {{ ONLINE_CATEGORY.length }}</p>
            </v-col>
            <v-col>
              <v-btn icon @click="getCategory">
                <v-icon>mdi-sync</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <br />
      <v-data-table
        :headers="headers"
        :items="ONLINE_CATEGORY"
        :search="search"
        :items-per-page="10"
        class="elevation-1"
      >
        <template v-slot:item.id="{ item }">
          <v-icon color="error" @click="removeCat(item)">mdi-delete</v-icon>
        </template>
        <template v-slot:item.image="{ item }">
          <template>
            <v-img :src="item.image" contain aspect-ratio="1.7" />
          </template>
        </template>
      </v-data-table>
      <v-dialog v-model="newSlide" persistent scrollable max-width="50%">
        <v-card>
          <v-card-text>
            <v-container>
              <v-text-field label="Name" required v-model="category_name"></v-text-field>
              <v-file-input
                label="Thumnail"
                show-size
                outlined
                accept="image/*"
                prepend-icon="mdi-camera"
                @change="onFileChange"
                v-model="image"
              ></v-file-input>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col>
                <v-btn color="error" block @click="newSlide = false">Close</v-btn>
              </v-col>

              <v-col>
                <v-btn color="green" dark block @click="addcategory">ADD</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="imageupdload" persistent max-width="600px">
        <v-card>
          <v-card-title>IMAGE UPLOAD</v-card-title>
          <v-card-actions>
            <v-row>
              <v-col>
                <v-btn color="error" block @click="imageupdload = false">Close</v-btn>
              </v-col>
              <v-col>
                <v-btn color="primary1" block dark @click="uploadImageServer">UPLOAD</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Item Name",
          align: "start",
          value: "name",
        },
        {
          text: "Item Image",
          value: "image",
          align: "center",
        },
        {
          text: "Action",
          align: "center",
          value: "id",
        },
      ],
      catBox: false,
      imageupdload: false,
      newSlide: false,
      editCat: false,
      category_name: "",
      editData: {
        id: "",
        name: "",
      },
      editImageId: "",
      image: null,
    };
  },
  activated() {
    this.getCategory();
  },
  computed: {
    ...mapGetters(["ONLINE_CATEGORY"]),
  },
  methods: {
    ...mapActions([
      "GET_ONLINE_CATEGORY",
      "NEW_ONLINE_CATEGORY",
      "UPDATE_ONLINE_CATEGORY",
      "UPLOAD_ONLINE_CATEGORY_IMAGE",
      "REMOVE_ONLINE_CATEGORY",
    ]),
    getCategory() {
      this.$store.commit("SET_LOADING", true);
      this.GET_ONLINE_CATEGORY().then(() => {
        this.$store.commit("SET_LOADING", false);
      });
    },
    addcategory() {
      this.NEW_ONLINE_CATEGORY({ name: this.category_name }).then(() => {
        this.category_name = "";
        this.newCat = false;
        this.$store.commit("SET_LOADING", false);
      });
    },
    EditCatItem(item) {
      this.editData = {
        id: item.id,
        name: item.name,
      };
      this.editCat = true;
    },
    updateCat() {
      if (this.editData.id != "" && this.editData.name != "") {
        this.$store.commit("SET_LOADING", true);
        this.UPDATE_ONLINE_CATEGORY(this.editData).then(() => {
          this.editCat = false;
          this.$store.commit("SET_LOADING", false);
        });
      } else {
        alert("Can not Update");
      }
    },
    editImage(item) {
      this.editImageId = item.id;
      this.image = null;
      this.imageupdload = true;
    },
    onFileChange(event) {
      this.image = event;
    },
    uploadImageServer() {
      if (this.editImageId != "" && this.image != null) {
        let formData = new FormData();
        formData.append("imagees", this.image);
        let data = JSON.stringify({ id: this.editImageId });
        formData.append("data", data);
        this.$store.commit("SET_LOADING", true);
        this.UPLOAD_ONLINE_CATEGORY_IMAGE(formData).then(() => {
          this.editImageId = "";
          this.image = null;
          this.imageupdload = false;
          this.$store.commit("SET_LOADING", false);
        });
      } else {
        alert("Can Not Upload Image");
      }
    },
    removeCat(item) {
      this.$store.commit("SET_LOADING", true);
      this.REMOVE_ONLINE_CATEGORY({ id: item.id }).then(() => {
        this.$store.commit("SET_LOADING", false);
      });
    },
  },
};
</script>

<style></style>
